import { render, staticRenderFns } from "./ModelSelect.vue?vue&type=template&id=b42bd82c&scoped=true"
import script from "./ModelSelect.vue?vue&type=script&lang=ts"
export * from "./ModelSelect.vue?vue&type=script&lang=ts"
import style0 from "./ModelSelect.vue?vue&type=style&index=0&id=b42bd82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42bd82c",
  null
  
)

export default component.exports